import { useState } from "react";
import { Logo } from "../Logo/Logo";
import { CountrySelector } from "../CountrySelector/CountrySelector";
// import { Search } from "../Search/Search";
import { ButtonLearnMore } from "../buttons/ButtonLearnMore/ButtonLearnMore";
import "./header.css";
import instagram from "../../images/icons/instagram.svg";
import facebook from "../../images/icons/facebook.svg";
import youtube from "../../images/icons/youtube.svg";
import { companyObject, productsObject, resourcesObject } from "./assets";

export const Header = () => {
  const [hoveredElement, setHoveredElement] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [mobileMenu, setMobileMenu] = useState(false);

  const handleMouseEnter = (element) => {
    !mobileMenu && setActiveMenu(element);
    !mobileMenu && setHoveredElement(element);
  };

  const handleMouseLeave = () => {
    !mobileMenu &&  setHoveredElement(null);
  };

  const onMobileMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  const onOpenMenu = (element) => {
    mobileMenu && setHoveredElement(element);
    setActiveMenu(element);

    element === hoveredElement && setHoveredElement(null)
  }

  let arrayMenu = [];

  switch (activeMenu) {
    case "company":
      arrayMenu = companyObject;
      break;
    case "products":
      arrayMenu = productsObject;
      break;
    case "resources":
      arrayMenu = resourcesObject;
      break;
    default:
      arrayMenu = [];
  }

  return (
    <header>
      <div className="header">
        <div className="left-section">
          <Logo />
          <nav className={`${mobileMenu && "open"}`}>
            <ul>
              <li
                className={
                  hoveredElement && hoveredElement !== "company"
                    ? "unactive"
                    : ""
                }
                onMouseEnter={() => handleMouseEnter("company")}
                onMouseLeave={handleMouseLeave}
                onClick={() => onOpenMenu("company")}
              >
                <a href="#" className="dropdown-link">
                  COMPANY
                </a>
                <div
                  onMouseEnter={() => handleMouseEnter("company")}
                  onMouseLeave={handleMouseLeave}
                ></div>
              </li>
              <li
                className={
                  hoveredElement && hoveredElement !== "products"
                    ? "unactive"
                    : ""
                }
                onMouseEnter={() => handleMouseEnter("products")}
                onMouseLeave={handleMouseLeave}
              >
                <a href="#" className="dropdown-link">
                  PRODUCTS
                </a>
                <div
                  onMouseEnter={() => handleMouseEnter("products")}
                  onMouseLeave={handleMouseLeave}
                ></div>
              </li>
              <li
                className={
                  hoveredElement && hoveredElement !== "resources"
                    ? "unactive"
                    : ""
                }
                onMouseEnter={() => handleMouseEnter("resources")}
                onMouseLeave={handleMouseLeave}
              >
                <a href="#" className="dropdown-link">
                  RESOURCES
                </a>
                <div
                  onMouseEnter={() => handleMouseEnter("resources")}
                  onMouseLeave={handleMouseLeave}
                ></div>
              </li>
              <li
                className={
                  hoveredElement && hoveredElement !== "contacts"
                    ? "unactive"
                    : ""
                }
                onMouseEnter={() => handleMouseEnter("contacts")}
                onMouseLeave={handleMouseLeave}
              >
                <a href="#">CONTACTS</a>
              </li>
            </ul>
            {mobileMenu && (
              <div className="social-media-section">
                <p>We're on social media</p>
                <div className="social-media-wrapper">
                  <a href="#" className="social-media">
                    <img src={instagram} alt="instagram" />
                  </a>
                  <a href="#" className="social-media">
                    <img src={facebook} alt="facebook" />
                  </a>
                  <a href="#" className="social-media">
                    <img src={youtube} alt="youtube" />
                  </a>
                </div>
              </div>
            )}
          </nav>
        </div>
        <div
          className={
            hoveredElement && hoveredElement !== "changeCountry"
              ? "unactive right-section"
              : "right-section"
          }
          onMouseEnter={() => handleMouseEnter("changeCountry")}
          onMouseLeave={handleMouseLeave}
        >
          <CountrySelector />
          {/* <Search isUnactive={hoveredElement} /> */}
          <div className="header-mobile" onClick={onMobileMenu}></div>
        </div>
      </div>
      {mobileMenu && <div className="mobile-menu"></div>}
      <div
        className="dropdown"
        style={{
          opacity:
            (hoveredElement === "company" ||
              hoveredElement === "products" ||
              hoveredElement === "resources") &&
            1,
          pointerEvents:
            (hoveredElement === "company" ||
              hoveredElement === "products" ||
              hoveredElement === "resources") &&
            "auto",
        }}
      >
        <div className="dropdown-items-wrapper">
          {arrayMenu?.items?.map((el) => (
            <div key={el.title} className="dropdown-item">
              <div className="images-wrapper">
                {mobileMenu ? (
                  <img
                    src={el.images[0]}
                    alt={el.images[0]}
                    key={el.images[0]}
                  />
                ) : (
                  el?.images?.map((item) => (
                    <img src={item} alt={item} key={item} />
                  ))
                )}
              </div>
              <div>
                <h4>{el.title}</h4>
              </div>
            </div>
          ))}
        </div>
        {arrayMenu?.button && (
          <ButtonLearnMore>{arrayMenu?.button}</ButtonLearnMore>
        )}
      </div>
    </header>
  );
};
